/**
 * v-permission 指令
 * 用法：v-permission="'user:create'"
 * 无权限时自动移除元素
 */
import store from '@/store'

export default {
  inserted(el, binding) {
    const { value } = binding
    if (!value) return
    const has = store.getters['user/hasPermission'](value)
    if (!has) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
